import React from 'react';
import moment from 'moment';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import Send from '@material-ui/icons/Send';
import {
  sendConfirmationMail,
  refundOrder,
} from '../schema/skidata-schema.graphql';
import { Mutation } from 'react-apollo';
import { withSnackbar } from '../../snackbar/SnackbarContext';
import localization from '../../../i18n/localization';
import CancelOrderButton from './CancelOrderButton';
import { TIME_ZONE } from '../../../i18n/config';

class OrderDetailsForm extends React.Component {
  successNotificationHandler(text) {
    return () => {
      this.props.addNotification('success', text);
    };
  }
  failureNotificationHandler(text) {
    return () => {
      this.props.addNotification('danger', text);
    };
  }

  render() {
    const {
      onCancelOrder,
      canceling,
      order: {
        id,
        saleId,
        confirmationNumber,
        keycardConfirmationNumber,
        createdAt,
        startDate,
        state,
        payment,
        tickets,
      },
    } = this.props;
    const ticket = tickets[0];

    const isActive = moment().isBetween(
      ticket.validFrom,
      ticket.validTo,
      'day',
      '[]'
    );

    return (
      <React.Fragment>
        <GridContainer>
          <GridItem xs={12} sm={6} md={4} lg={4}>
            <CustomInput
              labelText="Sale ID"
              inputProps={{ value: saleId, disabled: true }}
              dis
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          {confirmationNumber ? (
            <GridItem
              xs={12}
              sm={6}
              md={keycardConfirmationNumber ? 4 : 8}
              lg={keycardConfirmationNumber ? 4 : 8}
            >
              <CustomInput
                labelText="Pickup - Reservationsnummer "
                inputProps={{ value: confirmationNumber, disabled: true }}
                dis
                formControlProps={{
                  fullWidth: true,
                }}
              />
            </GridItem>
          ) : null}
          {keycardConfirmationNumber ? (
            <GridItem xs={12} sm={6} md={4} lg={4}>
              <CustomInput
                labelText="Keycard - Reservationsnummer"
                inputProps={{
                  value: keycardConfirmationNumber,
                  disabled: true,
                }}
                dis
                formControlProps={{
                  fullWidth: true,
                }}
              />
            </GridItem>
          ) : null}
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={6} md={3} lg={3}>
            <CustomInput
              labelText="Erstellt am"
              inputProps={{
                value: moment(createdAt).format('DD.MM.YYYY HH:mm'),
                disabled: true,
              }}
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={3} lg={3}>
            <CustomInput
              labelText={'G\u00fcltig ab'}
              inputProps={{
                value: moment(startDate).format('DD.MM.YYYY'),
                disabled: true,
              }}
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={3} lg={3}>
            <CustomInput
              labelText={'G\u00fcltig bis'}
              inputProps={{
                value: moment(tickets[0].validTo).format('DD.MM.YYYY'),
                disabled: true,
              }}
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3} lg={3}>
            <CustomInput
              labelText="Skitage"
              inputProps={{
                value: localization.de[tickets[0].skidays],
                disabled: true,
              }}
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer />
        <div
          style={{
            marginTop: 20,
            display: 'flex',
            flexDirection: 'row-reverse',
          }}
        >
          <Mutation
            mutation={sendConfirmationMail}
            onCompleted={this.successNotificationHandler(
              'Best\u00e4tigungs Email versendet'
            )}
            onError={this.failureNotificationHandler(
              'Best\u00e4tigungs Email konnte nicht versendet werden!'
            )}
          >
            {sendConfirmationMail =>
              state !== 'CANCELLED' ? (
                <Button
                  style={{ marginRight: 20 }}
                  color="info"
                  onClick={() =>
                    sendConfirmationMail({ variables: { orderId: id } })
                  }
                >
                  <span style={{ marginRight: 10 }}>
                    Best&auml;tigungs Email senden
                  </span>
                  <Send />
                </Button>
              ) : null
            }
          </Mutation>
        </div>
      </React.Fragment>
    );
  }
}

export default withSnackbar(OrderDetailsForm);



// WEBPACK FOOTER //
// ./src/views/skidata/components/OrderDetailsForm.jsx